import SectionShell from "./SectionShell";

// Text-only variant. `blocks` is a list of facts laid out over `columns`; a
// plain `body` flows newspaper-style over the same column count.
export default function TextSection(props: { section: CaseStudyTextSectionT }) {
  const { title, columns = 2, body, blocks } = props.section;

  const columnStyle = { "--cs-columns": String(columns) } as React.CSSProperties;

  return (
    <SectionShell variant="text" title={title}>
      {blocks ? (
        <ul className="case-text-grid" style={columnStyle}>
          {blocks.map((block, index) => (
            <li className="case-text-block" key={index}>
              {block.title ? <h3 className="case-text-block-title">{block.title}</h3> : null}
              <p className="case-text-block-body">{block.body}</p>
            </li>
          ))}
        </ul>
      ) : null}
      {body ? (
        <p className="case-text-flow" style={columnStyle}>
          {body}
        </p>
      ) : null}
    </SectionShell>
  );
}
